"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingActivityUpdate = exports.BillingActivityCreate = exports.BillingActivityQuery = exports.SubscriptionBillingActivityTransport = exports.BillingActivityTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const invoice_1 = require("../../invoice");
const CommercialLineItem_1 = require("./CommercialLineItem");
const CommercialSubscription_1 = require("./CommercialSubscription");
const shared_1 = require("./shared");
exports.BillingActivityTransport = typebox_1.Type.Intersect([
    shared_1.BillingSharedFields,
    typebox_1.Type.Object({
        billingDetails: typebox_1.Type.Object({
            id: typebox_1.Type.String({ format: 'uuid' }),
            haulerID: typebox_1.Type.String({ format: 'uuid' }),
            customerID: typebox_1.Type.String({ format: 'uuid' }),
            subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
            startDate: typebox_1.Type.String({ format: 'date' }),
            endDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
            billingUnit: typebox_1.Type.String(),
            billingLength: typebox_1.Type.Integer({ minimum: 0 }),
            billingDay: typebox_1.Type.Integer({ minimum: 1 }),
            autopayEnabled: typebox_1.Type.Boolean(),
            autopayStripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
            autopaySource: typebox_1.Type.Optional(typebox_1.Type.String()),
            autopayProcessor: typebox_1.Type.Optional(invoice_1.AutopaySourceProcessorTransport),
            taxRate: typebox_1.Type.Number({ minimum: 0, maximum: 1 }),
            paymentTerm: typebox_1.Type.Integer({ minimum: 0 }),
            paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
        }),
        lineItems: typebox_1.Type.Array(CommercialLineItem_1.CommercialLineItemTransport),
        estimatedTax: typebox_1.Type.Optional(typebox_1.Type.Integer()),
        subTotal: typebox_1.Type.Integer(),
        total: typebox_1.Type.Optional(typebox_1.Type.Integer()),
        date: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date', description: 'deprecated' })),
        issueDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        dueDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        autopayDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        billingPeriodStart: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        billingPeriodEnd: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        receivableID: typebox_1.Type.Optional(typebox_1.Type.String({
            format: 'uuid',
            description: 'The ID of the receivable that this billing activity is associated with. If unset, one will be created automatically. Set to 00000000-0000-0000-0000-000000000000 if one should not be created automatically.',
        })),
        amountPaid: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
        billNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
        subscription: CommercialSubscription_1.CommercialSubscription,
    }),
]);
exports.SubscriptionBillingActivityTransport = typebox_1.Type.Omit(exports.BillingActivityTransport, [
    'billingDetails',
    'lineItems',
    'subscription',
    'metadata',
]);
exports.BillingActivityQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.BillingActivityCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BillingActivityTransport, [
        'id',
        'haulerID',
        'customerID',
        'billingDetails',
        'lineItems',
        'subTotal',
        'total',
        'subscription',
        'metadata',
    ]),
    typebox_1.Type.Object({
        billingDetailsID: typebox_1.Type.String({ format: 'uuid' }),
        lineItemIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
exports.BillingActivityUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BillingActivityTransport, [
        'id',
        'haulerID',
        'customerID',
        'billingDetails',
        'billNumber',
        'lineItems',
        'subTotal',
        'total',
        'estimatedTax',
        'subscription',
        'metadata',
    ]),
    typebox_1.Type.Object({
        billingDetailsID: typebox_1.Type.String({ format: 'uuid' }),
        lineItemIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
        estimatedTax: (0, common_1.Nullable)(typebox_1.Type.Integer()),
        billNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
    }),
]));
//# sourceMappingURL=BillingActivity.js.map